import styled from 'styled-components';
import { Paragraph } from '../Paragraph/Paragraph';

/**
 * @extends Paragraph
 * @since 8.28.0
 */
var ComboboxAdditional = /*#__PURE__*/styled(Paragraph).withConfig({
  displayName: "ComboboxAdditional",
  componentId: "c11n-8-111-1__sc-1gaarm6-0"
})([""]);
ComboboxAdditional.displayName = 'ComboboxAdditional';

/** @component */
export { ComboboxAdditional };